import { createContext, useEffect, useState } from "react";
import OptionSwitcher from "../OptionSwitch";
import EventList from "./EventList";
import { EVENT_TAB_VALUE } from "../../constants/event";
import { useUrlParam } from "../../hook/useUrlParam";
import { EVENTS_PAGE } from "../../constants/app-constants";

export const EventContext = createContext({ translation: {} });

export default function EventListPage({ props }) {
  const { getParam: getCategory, setParam: setCategory } = useUrlParam(EVENTS_PAGE.CATEGORY);
  
  const tabs = [
    { label: props?.tabOngoing, value: EVENT_TAB_VALUE.ONGOING },
    { label: props?.tabCompleted, value: EVENT_TAB_VALUE.COMPLETED }
  ];
  const [selectedTab, setSelectedTab] = useState(EVENT_TAB_VALUE.ONGOING);

  const handleSelect = (v) => {
    setSelectedTab(v);
    if (v === EVENT_TAB_VALUE.COMPLETED) {
      setCategory(v);
    } else {
      setCategory(null);
    }
  };

  useEffect(() => {
      const savedCategory = getCategory();
      if (savedCategory) {
          setSelectedTab(savedCategory);
      }
  }, []);

  return (
    <EventContext.Provider value={{ translation: props }}>
      <div className="flex flex-column align-content-center justify-content-center main-content-wrapper">
        <div class="page-title-container">
          <h1 class="keduall-typography heading-h1-semibold-600 text-primary-txt-color animate__animated animate__fadeInDown"> {props?.eventPageHeading}</h1>
          {/* <h4 class="keduall-typography heading-h4-normal-400 text-default-txt-color">{translations.headerSubtitle}</h4> */}
          <div className="mx-auto mt-5 flex justify-content-center animate__animated animate__flipInY">
            <OptionSwitcher options={tabs} onSelect={handleSelect} size="large" selected={selectedTab}/>
          </div>
        </div>

        <EventList
          isExpired={selectedTab === EVENT_TAB_VALUE.COMPLETED}
          trans={props}
        />
      </div>
    </EventContext.Provider>
  );
}